// frontend/src/site/templates/TemplateCorretorLovable/components/AboutSection.jsx
import { Award, Shield, Users, Target } from 'lucide-react';

const AboutSection = ({ siteConfig }) => {
  const nome = siteConfig?.nome || siteConfig?.displayName || 'Corretor';
  const bio =
    siteConfig?.bio ||
    'Atendimento consultivo e foco total em encontrar a melhor oportunidade para você.';
  const especialidades = Array.isArray(siteConfig?.especialidades)
    ? siteConfig.especialidades
    : [];

  const features = [
    {
      icon: Award,
      title: 'Experiência e Técnica',
      description: 'Atendimento orientado a resultado, com visão de mercado.',
    },
    {
      icon: Shield,
      title: 'Segurança na Negociação',
      description: 'Apoio e orientação para uma transação mais segura.',
    },
    {
      icon: Users,
      title: 'Atendimento Personalizado',
      description: 'Cada cliente tem um objetivo — eu ajudo a chegar lá.',
    },
    {
      icon: Target,
      title: 'Estratégia de Compra/Venda',
      description: 'Negociação estruturada para buscar as melhores condições.',
    },
  ];

  return (
    <section id="sobre" className="py-24 lg:py-32 bg-beige-soft">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          {/* Content */}
          <div className="space-y-8">
            <div className="space-y-4">
              <p className="text-gold font-medium tracking-wider text-sm uppercase">
                Sobre
              </p>
              <h2 className="font-serif text-4xl lg:text-5xl font-semibold text-foreground leading-tight">
                {nome}
              </h2>
            </div>

            <div className="space-y-6 text-muted-foreground leading-relaxed">
              <p>{bio}</p>
            </div>

            {!!especialidades.length && (
              <div className="pt-4">
                <p className="text-sm font-medium text-foreground mb-3">
                  Especialidades
                </p>
                <div className="flex flex-wrap gap-2">
                  {especialidades.slice(0, 10).map((item) => (
                    <span
                      key={item}
                      className="px-4 py-2 bg-secondary text-secondary-foreground text-sm rounded-full"
                    >
                      {item}
                    </span>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* Features Grid */}
          <div className="grid sm:grid-cols-2 gap-6">
            {features.map((feature, index) => (
              <div
                key={feature.title}
                className="p-6 bg-card rounded-xl border border-border hover:border-gold/30 transition-colors duration-300 shadow-card group"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="w-12 h-12 bg-gold/10 rounded-lg flex items-center justify-center mb-4 group-hover:bg-gold/20 transition-colors">
                  <feature.icon className="w-6 h-6 text-gold" />
                </div>
                <h3 className="font-serif text-xl font-semibold text-foreground mb-2">
                  {feature.title}
                </h3>
                <p className="text-muted-foreground text-sm leading-relaxed">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
